import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// import Restricted from './Restricted';
import { View } from '../reducers/ViewConfigType';
import CrudRoute from './CrudRoute';
import { getViewComponent } from '../util/getResourceListFromConfig';

const AdminRoutes: React.SFC<{
    customRoutes: Route[];
    nonDefaultResourceViews: View[];
    resources: any[]; // tslint:disable-line
    dashboard: any; // tslint:disable-line
}> = ({ customRoutes, nonDefaultResourceViews, resources = [], dashboard }) => (
    <Switch>
        {customRoutes &&
            customRoutes.map((route, index) => (
                <Route
                    key={index}
                    exact={route.props.exact}
                    path={route.props.path}
                    component={route.props.component}
                    render={route.props.render}
                    children={route.props.children}
                />
            ))}
        {resources.map(resource => (
            <Route
                path={`/${resource.name}`}
                key={resource.name}
                render={() => (
                    <CrudRoute
                        resource={resource.name}
                        list={resource.list}
                        create={resource.create}
                        edit={resource.edit}
                        show={resource.show}
                        remove={resource.remove}
                        options={resource.options}
                        possibleMatchView={resource.possibleMatchView}
                        specificMatchView={resource.specificMatchView}
                    />
                )}
            />
        ))}
        {nonDefaultResourceViews
            .filter(f => f.route)
            .sort((a, b) => (b as { route: string }).route.length - (a as { route: string }).route.length) // longest first
            .map(v => (
                <Route
                    path={(v as { route: string }).route.startsWith('/') ? v.route : `/${v.route}`}
                    exact={true}
                    key={v.name + ':' + v.route}
                    render={getViewComponent(v)}
                />
            ))}
        {dashboard ? (
            <Route
                exact={true}
                path="/"
                render={
                    routeProps =>
                        // <Restricted authParams={{ route: 'dashboard' }} {...routeProps}>
                        React.createElement(dashboard)
                    // </Restricted>
                }
            />
        ) : (
            resources[0] && <Route exact={true} path="/" render={() => <Redirect to={`/${resources[0].name}`} />} />
        )}
    </Switch>
);

export default AdminRoutes;
